import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

const SignUp = () => {
  const { instance } = useMsal();

  // useEffect(() => {
  //   instance.loginRedirect(loginRequest).catch((e) => {
  //     console.error("Login redirect failed", e);
  //   });
  // }, [instance]);

  return (
    <div>
      <h1>Sign Up</h1>
      <p>Redirecting to Azure B2C sign up page...</p>
    </div>
  );
};

export default SignUp;
